module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-43.e44bfee0.png";